module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/goodsback.64a75c9a.jpg";